import { DEFAULT_API_ADMIN, mapPath } from '../../constants'
import { getChainId, httpClientReactAdmin } from '../../lib'

export default async (resourceName, params) => {
  const path = mapPath[resourceName]

  const URL = `${DEFAULT_API_ADMIN}/${(path || resourceName || '').replace('chainId', getChainId())}/${params.id}`

  const { json } = await httpClientReactAdmin(URL, { method: 'DELETE' })

  return json
}
